export default __webpack_public_path__ + "static/media/Potato Seeds.7a830771.PNG";